import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';

class BbColumnedField extends React.Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        field: PropTypes.object.isRequired
    };

    innerTypeStyles = {
        "radio": { display: "flex" }
    };

    render() {
        const thinInput = this.props.thinInput === true;
        const noWidthOverride = this.props.noWidthOverride === true;

        return (
            <div className="columns">
                <div className={classnames({
                        "column": true,
                        "bb-input-label-column": true,
                        "is-one-third": !thinInput,
                        "is-three-fifths": thinInput,
                        "no-width-override": noWidthOverride
                    })}
                >
                    <div className="vertically-centered">
                        <span style={this.props.useDefaultColorOnDisabled && { color: "initial" }}>
                            {ReactHtmlParser(this.props.label)}
                        </span>
                    </div>
                </div>
                <div className={classnames({
                        "column": true,
                        "bb-input-column": true,
                        "is-two-thirds": !thinInput,
                        "is-two-fifths": thinInput,
                        "no-width-override": noWidthOverride
                    })}
                    style={this.innerTypeStyles[this.props.innerType]}
                >
                    {this.props.field}
                </div>
            </div>
        )
    }
}

export default BbColumnedField;
